/*
 * Categories Type definitions and meta-information
 * */

export class CategoriesTypeDef {
  constructor() {
    this.type = '';
    this.category = '';
    this.title = '';
    this.description = '';
    this.defaultName = '';
    this.icon = 'lightbulb-on-20';
    this.helpUrl = '';
    this.props = [];
  }
}

export const emptyCategoriesType = new CategoriesTypeDef();

// Common Categories props
export const commonCategoriesProps = [
  // TODO
];

/*
 * Categories Type Definition: Standard Categories
 * */
export class CategoriesTypeStandard extends CategoriesTypeDef {
  constructor() {
    super();
    this.type = 'standard';
    this.category = 'categories';
    this.title = 'Categories';
    this.description = 'Hierarchy of Categories to classify Interactions';
    this.defaultName = 'New Categories';
    this.helpUrl = '/help/kb/categories';
    this.icon = 'file-tree-outline';
    this.props = commonCategoriesProps.concat([
      {
        name: 'kpiCollection',
        advanced: false,
        type: 'kpiCollection',
        title: 'KPI Collection',
        default: false,
        description: 'Associate KPIs with these Categories.',
      },
      // more as needed
    ]);
    this.propsByName = {};
    this.props.map((p) => {
      this.propsByName[p.name] = p;
    });
  }
}

// All known Categories Type Defs by type
export const CAT_TYPE_DEFS = {
  standard: new CategoriesTypeStandard(),
};

// Meta-information about all known Categories Types
export const CAT_TYPE_META = Object.values(CAT_TYPE_DEFS).map((x) => {
  return {
    type: x.type,
    title: x.title,
    description: x.description,
    helpUrl: x.helpUrl,
    icon: x.icon,
  };
});

export function getCategoriesTypeDef(categoriesType) {
  return categoriesType in CAT_TYPE_DEFS ? CAT_TYPE_DEFS[categoriesType] : emptyCategoriesType;
}
